import { DOCUMENT } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { HlmButtonDirective } from '@spartan-ng/ui-button-helm';
import { environment } from '../../../environments/environment';
import { SEOService } from '../../services/seo.service';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [RouterLink, HlmButtonDirective],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
})
export class NotFoundComponent implements OnInit {
  private document = inject(DOCUMENT);

  constructor(private seoService: SEOService) {}

  ngOnInit(): void {
    this.setSeoMetadata();
  }

  private setSeoMetadata(): void {
    // For 404 pages, the canonical URL should point to the 404 page itself,
    // not the current URL which could be any random invalid URL
    const canonicalUrl = `${environment.canonicalOrigin}/404`;

    this.seoService.updateTags({
      title: 'Page Not Found | Summerry',
      description:
        'The page you requested could not be found. Return to Summerry homepage to access the latest AI news and summaries.',
      type: 'website',
      url: canonicalUrl, // Explicitly set canonical URL
    });
  }
}
